import React, { Component } from "react";
import Card from "../../shared/Card";

class FacilityAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
    };
  }

  formatZipCode(zipcode) {
    return zipcode.slice(0, 5);
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  render() {
    const facilityAddress = (
      <Card
        cardType="default"
        cardHeader="Facility Address"
        headerColor="#046B99"
        headerTextColor="white"
        cardBody={
          <div className={`${this.props.TRANS_ID > 0 ? "facility-address-card-2" : "facility-address-card"} `}>
            <div>{`${this.props.FAC_ST1}`}</div>
            <div>
              {`${this.props.FAC_CITY}`}, CA{" "}
              {`${this.formatZipCode(this.props.FAC_ZIP)}`}
            </div>
            <div>{`${this.props.CNTY_NAME} County`}</div>
            <div>
              ({`${this.props.DD_Latitude}`}, {`${this.props.DD_Longitude}`})
            </div>
          </div>
        }
        cardColor="white"
      />
    );

    return <div>{facilityAddress}</div>;
  }
}

export default FacilityAddress;
